import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('imagine-pay', (editor, opts) => {
  const default_types = {
    imaginePay: 'imagine-pay',
    imaginePayToken: 'imagine-pay-card-token',
  };
  const default_labels = {
    imaginePay: 'Imagine Pay',
    imaginePayToken: 'Imagine Pay Card Token',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelShoppingCartCategory: 'Payment Gateway',
    },
    ...opts,
  };
  loadComponents(editor, options);
});
